module.exports = __webpack_public_path__ + "img/bookmarked.7368eb41.svg";